import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetDataToken } from "../../../hooks/useGetData";
import notify from "../../../Components/Utilities/notify";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";



//get all users
export const getAllBranches = createAsyncThunk(
    "/usersSlice/users",
    async (query='') => {
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            const response = await useGetDataToken(`/api/v1/branches?gender=${user?.cln_typ?.trim()}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);


